import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { clearStoredUserData } from '@/hooks/use-onboarding-tour';
import { LogOut } from 'lucide-react';

function LogoutButton() {
	const history = useHistory();

	const handleLogout = () => {
		clearStoredUserData();
		history.push('/');
		history.go(0);
	};

	return (
		<Link
			className="cyber-user-dropdown__item"
			to="#"
			onClick={handleLogout}
		>
			<div className="cyber-user-dropdown__item-icon">
				<LogOut size={18} />
			</div>
			Cerrar sesión
		</Link>
	);
}

export default LogoutButton;
